module.exports = __webpack_public_path__ + "static/media/ic_merge.23640d0e.svg";